import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';

/**
 * Guarda de rota: renderiza as rotas filhas (Outlet) só com usuário logado;
 * caso contrário redireciona para /entrar. A "autorização" real é do backend
 * — aqui é só UX (token inválido cai no interceptor do api.ts de toda forma).
 */
const PrivateRoutes = () => {
  const isLoggedIn = useAppSelector(selectUser.isLoggedIn);

  return isLoggedIn ? (
    <>
      <Outlet />
    </>
  ) : (
    <Navigate to="/entrar" />
  );
};

export default PrivateRoutes;
